// UrlLoader.jsx
import React from 'react';
import PropTypes from 'prop-types';

class UrlLoader extends React.PureComponent {
  componentDidMount() {
    this.props.urlHandler({ url: new URL(location.href) });
  }

  render() {
    return null;
  }
}

UrlLoader.propTypes = {
  urlHandler: PropTypes.func,
};

UrlLoader.defaultProps = {
  urlHandler: () => null,
};

export default UrlLoader;
